import { ServerResponse } from "http";

export type SetResponseCacheOptions = {
  maxAge: number;
  access: "public" | "private";
};
const defaultCacheOptions: SetResponseCacheOptions = {
  maxAge: 30,
  access: "private",
};

export function setResponseCache(
  res: ServerResponse,
  options: Partial<SetResponseCacheOptions> = defaultCacheOptions
): ServerResponse {
  const opt = { ...defaultCacheOptions, ...options };
  const ageKey = opt.access === "public" ? "s-maxage" : "max-age";
  const value = [opt.access, `${ageKey}=${opt.maxAge}`].join(", ");
  return res
    .setHeader("Vary", "User-Agent, Cookie")
    .setHeader("Cache-Control", value);
}
